// extracted by mini-css-extract-plugin
export var avatarContainer = "_7b-0";
export var avatarTypingWave = "_7b-i";
export var gray = "_7b-f";
export var green = "_7b-c";
export var icon = "_7b-9";
export var image = "_7b-1";
export var lg = "_7b-6";
export var md = "_7b-5";
export var presenceDot = "_7b-b";
export var red = "_7b-d";
export var sm = "_7b-4";
export var status = "_7b-a";
export var typingDot = "_7b-h";
export var typingPill = "_7b-g";
export var xl = "_7b-7";
export var xs = "_7b-3";
export var xxl = "_7b-8";
export var xxs = "_7b-2";
export var yellow = "_7b-e";